/* LEHUA · Cart Drawer — Free Shipping Bar dinâmica
   Threshold: R$ 299,90 (29990 cents). Insere uma barra de progresso
   no topo do cart drawer com mensagem dinâmica baseada em cart.total_price. */

(function () {
  'use strict';

  const THRESHOLD_CENTS = 29990;

  function formatBRL(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function buildBarHTML(totalCents) {
    const remaining = Math.max(0, THRESHOLD_CENTS - totalCents);
    const pct = Math.min(100, Math.round((totalCents / THRESHOLD_CENTS) * 100));
    const unlocked = remaining === 0;
    const msg = unlocked
      ? '🎉 Você ganhou frete grátis!'
      : 'Faltam <strong>' + formatBRL(remaining) + '</strong> pra frete grátis';
    return (
      '<div class="lehua-shipping-bar' + (unlocked ? ' lehua-shipping-bar--unlocked' : '') + '" data-lehua-shipping-bar>' +
        '<div class="lehua-shipping-bar__msg' + (unlocked ? ' lehua-shipping-bar__msg--unlocked' : '') + '">' + msg + '</div>' +
        '<div class="lehua-shipping-bar__progress">' +
          '<div class="lehua-shipping-bar__progress-fill" style="width:' + pct + '%"></div>' +
        '</div>' +
      '</div>'
    );
  }

  function getCartTotal() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : null)
      .then(c => c ? c.total_price : 0)
      .catch(() => 0);
  }

  function makeBar(totalCents) {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = buildBarHTML(totalCents);
    return wrapper.firstChild;
  }

  function injectBar(totalCents) {
    // Anti-duplicação: remove TODAS as barras existentes antes de injetar
    document.querySelectorAll('[data-lehua-shipping-bar]').forEach(el => el.remove());

    // 1) Cart drawer — injeta uma única barra no topo do conteúdo
    const drawer = document.querySelector('cart-drawer-component, .cart-drawer');
    if (drawer) {
      const target = drawer.querySelector('.cart-drawer__content') ||
                     drawer.querySelector('.cart-drawer__dialog');
      if (target) target.insertBefore(makeBar(totalCents), target.firstChild);
    }

    // 2) Página /cart — só se o form NÃO estiver dentro do drawer (senão duplica)
    const cartPage = document.querySelector('.cart-form, main #cart, main [class*="cart-page"]');
    if (cartPage && !cartPage.closest('cart-drawer-component, .cart-drawer')) {
      cartPage.insertBefore(makeBar(totalCents), cartPage.firstChild);
    }
  }

  function refresh() {
    getCartTotal().then(injectBar);
  }

  // Initial inject when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  // Re-inject when cart drawer opens
  document.addEventListener('click', e => {
    const t = e.target.closest('[href="/cart"], [data-action="open-cart-drawer"], .header__icon--cart, .cart-icon');
    if (t) setTimeout(refresh, 250);
  }, true);

  // Listen for cart updates (Shopify dispatches these)
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('cart:item:added', refresh);

  // Fallback: observe cart drawer open via attribute change
  const drawerObserver = new MutationObserver(muts => {
    muts.forEach(m => {
      if (m.attributeName === 'open' || m.attributeName === 'aria-hidden') {
        setTimeout(refresh, 100);
      }
    });
  });
  document.querySelectorAll('cart-drawer-component, .cart-drawer__dialog').forEach(el => {
    drawerObserver.observe(el, { attributes: true });
  });

  // Expose for manual refresh
  window.lehuaShippingBarRefresh = refresh;
})();
